import '@/assets/scss/app.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-select/dist/vue-select.css'
import 'dropify/dist/css/dropify.min.css'
import 'dropify/dist/js/dropify.js'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// filter
import './filters/fomatDate'
import './filters/employeeFilters'
import './filters/generalFilters'

// Components plugins
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import ToggleButton from 'vue-js-toggle-button'
import VueCompositionAPI from '@vue/composition-api'

Vue.config.productionTip = false

// add plugins to Vue
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(ToggleButton)
Vue.use(VueCompositionAPI)

router.beforeEach((to, from, next) => {
  const isLoggeIn = store.getters['auth/isLoggeIn']
  if (to?.meta?.requiresAuth) {
    if (isLoggeIn) {
      next()
    } else {
      store.commit('auth/detroyToken')
      router.push({
        name: 'login'
      })
    }
  } else if (to?.meta?.requiresVisitor) {
    if (isLoggeIn) {
      router.push({
        name: 'home'
      })
    } else {
      next()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
